/**
 * Shows a confirmation modal when customers try to remove required hardware
 * (Hubrings, TPMS, Lug Installation Kit) while wheels/tires remain in the cart.
 * Product and variant IDs are loaded from the required_wheel_tire_products metaobject.
 */
(function () {
  var confirmedRemoval = false;
  var pendingAction = null;
  var modal = null;
  var config = null;

  function getConfig() {
    if (config) return config;
    var cm = window.Convermax && window.Convermax.config;
    if (!cm || !cm.hardwareRemovalWarning) return null;
    config = cm.hardwareRemovalWarning;
    return config;
  }

  function getCartRoot() {
    return (window.theme && window.theme.routes && window.theme.routes.root) ||
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      '/';
  }

  function getHardwareProduct(variantId) {
    var cfg = getConfig();
    if (!cfg || !cfg.products || !cfg.products.length) return null;
    var id = String(variantId);
    for (var i = 0; i < cfg.products.length; i++) {
      if (String(cfg.products[i].variantId) === id) {
        return cfg.products[i];
      }
    }
    return null;
  }

  function cartHasWheelTire(cartItems, excludeVariantId) {
    var cfg = getConfig();
    var types = cfg.wheelTireTypes || [];
    var exclude = String(excludeVariantId);

    for (var i = 0; i < cartItems.length; i++) {
      var item = cartItems[i];
      if (String(item.variant_id) === exclude) continue;
      var pt = (item.product_type || '').toLowerCase().trim();
      if (types.indexOf(pt) !== -1) return true;
    }
    return false;
  }

  function fetchCart() {
    var root = getCartRoot().replace(/\/?$/, '/');
    return fetch(root + 'cart.js', {
      headers: { Accept: 'application/json' }
    }).then(function (res) { return res.json(); });
  }

  function shouldWarn(variantId) {
    var cfg = getConfig();
    if (!cfg || !getHardwareProduct(variantId)) {
      return Promise.resolve(false);
    }

    if (!cfg.requireWheelTireInCart) {
      return Promise.resolve(true);
    }

    return fetchCart().then(function (cart) {
      return cartHasWheelTire(cart.items || [], variantId);
    }).catch(function () {
      return false;
    });
  }

  function getCartItemFromTarget(target) {
    return target.closest('[data-cart-item]');
  }

  function getVariantIdFromItem(item) {
    if (!item) return null;
    return item.getAttribute('data-variant-id');
  }

  function isRemoveClick(target) {
    return target.matches('[data-item-remove]') || !!target.closest('[data-item-remove]');
  }

  function isQuantityMinusClick(target) {
    return target.matches('[data-quantity-minus]') || !!target.closest('[data-quantity-minus]');
  }

  function getQuantityField(item) {
    if (!item) return null;
    return item.querySelector('[data-quantity-field]');
  }

  function openModal(productName, trigger, type) {
    if (!modal) return;

    var cfg = getConfig();
    var strings = cfg.strings || {};
    var bodyTemplate = strings.body || '';
    var bodyText = bodyTemplate.replace(/\{\{\s*product\s*\}\}/g, productName);

    var titleEl = modal.querySelector('[data-hardware-removal-title]');
    var bodyEl = modal.querySelector('[data-hardware-removal-body]');

    if (titleEl && strings.title) titleEl.textContent = strings.title;
    if (bodyEl) bodyEl.textContent = bodyText;

    pendingAction = { trigger: trigger, type: type };
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('hardware-removal-modal-open');

    var keepBtn = modal.querySelector('[data-hardware-removal-keep]');
    if (keepBtn) keepBtn.focus();
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('hardware-removal-modal-open');
    pendingAction = null;
  }

  function executePendingRemoval() {
    if (!pendingAction || !pendingAction.trigger) {
      closeModal();
      return;
    }

    var trigger = pendingAction.trigger;
    closeModal();
    confirmedRemoval = true;
    trigger.click();
    setTimeout(function () {
      confirmedRemoval = false;
    }, 300);
  }

  function handleCartInteraction(event) {
    if (confirmedRemoval) return;

    var cfg = getConfig();
    if (!cfg || !cfg.products || !cfg.products.length) return;

    var target = event.target;
    var item = getCartItemFromTarget(target);
    if (!item) return;

    var variantId = getVariantIdFromItem(item);
    var hardware = getHardwareProduct(variantId);
    if (!hardware) return;

    var isRemove = isRemoveClick(target);
    var isMinus = isQuantityMinusClick(target);

    if (!isRemove && !isMinus) return;

    if (isMinus) {
      var field = getQuantityField(item);
      var currentQty = field ? parseInt(field.value, 10) : 0;
      if (currentQty !== 1) return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    shouldWarn(variantId).then(function (warn) {
      if (!warn) {
        confirmedRemoval = true;
        target.click();
        setTimeout(function () {
          confirmedRemoval = false;
        }, 300);
        return;
      }

      var triggerEl = isRemove
        ? (target.matches('[data-item-remove]') ? target : target.closest('[data-item-remove]'))
        : (target.matches('[data-quantity-minus]') ? target : target.closest('[data-quantity-minus]'));

      openModal(hardware.name, triggerEl, isRemove ? 'remove' : 'quantity');
    });
  }

  function bindModalEvents() {
    if (!modal) return;

    modal.querySelectorAll('[data-hardware-removal-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    var keepBtn = modal.querySelector('[data-hardware-removal-keep]');
    if (keepBtn) keepBtn.addEventListener('click', closeModal);

    var confirmBtn = modal.querySelector('[data-hardware-removal-confirm]');
    if (confirmBtn) confirmBtn.addEventListener('click', executePendingRemoval);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal();
      }
    });
  }

  function init() {
    if (!getConfig()) return;

    modal = document.querySelector('[data-hardware-removal-modal]');
    if (!modal) return;

    bindModalEvents();
    document.addEventListener('click', handleCartInteraction, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
